import http from "../config/axios";


export async function list_restaurant_orders_by_restaurant_id({ restaurantId, limit, offset, status_filter }:any) {
    const url = `/restaurant_order/list_by_restaurant/${restaurantId}`;
    try {
        const response = await http.request({
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            url,
            params: {
                limit,
                offset,
                status_filter,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        throw error;
    }
}

export async function list_restaurant_orders () {
    const url = `/restaurant_order/list`;
    try {
        const response = await http
            .request({
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                url,
            });
        return response.data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        throw error;
    }
}

export async function update_order({ restaurant_order_id, status }:any) {
    const url = `/restaurant_order/update_order/${restaurant_order_id}`;
    try {
      const response = await http.request({
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        url,
        data: {
          status,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar pedido:", error);
      throw error;
    }
  }

export async function update_order_payment_status(restaurant_order_payment_id:any, data:any) {
    const url = `/restaurant_order/update_order_payment/${restaurant_order_payment_id}`;
    try {
      const response = await http.request({
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        url,
        data: data,
      });
      return response.data;
    } catch (error) {
      console.error("Error making the request:", error);
      throw error;
    }
  }

export async function list_restaurant_orders_by_user ({ user_id }: { user_id: string }) {
    const url = `/restaurant_order/list_by_user/${user_id}`;
    try {
        const response = await http
            .request({
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                url,
            });
        return response.data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        throw error;
    }
}